<template>
  <p v-if="region || citiesText || updated" class="is-size-7 has-text-grey" dir="rtl" data-test="region-summary">
    <span v-if="region" data-test="region-text">{{ region }}</span>
    <span v-if="citiesText" data-test="region-cities"><span v-if="region"> · </span>ערים: {{ citiesText }}</span>
    <span v-if="updated" data-test="region-updated"><span v-if="region || citiesText"> · </span>{{ updated }}</span>
  </p>
</template>

<script>
import moment from 'moment'
import { updatedLine } from './chat_labels'

// VA2 - "region · ערים: a, b · עודכן DD/MM/YYYY על ידי X" under the region input.
// Region and cities carry separate stamps; the newer one is shown.
export default {
  name: 'PreferredRegionSummary',
  props: {
    region: { type: String, default: '' },
    cities: { type: Array, default: () => [] },
    regionUpdatedAt: { type: String, default: null },
    regionUpdatedBy: { type: [String, Number], default: null },
    citiesUpdatedAt: { type: String, default: null },
    citiesUpdatedBy: { type: [String, Number], default: null }
  },
  computed: {
    citiesText () {
      return (Array.isArray(this.cities) ? this.cities : [])
        .map(c => (c && typeof c === 'object' ? c.name : c))
        .filter(Boolean)
        .join(', ')
    },
    updated () {
      const stamps = [
        { at: this.regionUpdatedAt, by: this.regionUpdatedBy },
        { at: this.citiesUpdatedAt, by: this.citiesUpdatedBy }
      ].filter(s => s.at && moment(s.at).isValid())
      if (!stamps.length) return ''
      stamps.sort((a, b) => moment(b.at).valueOf() - moment(a.at).valueOf())
      return updatedLine(stamps[0].at, stamps[0].by)
    }
  }
}
</script>
